<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }} <small class="text-muted">({{ totalItems }})</small>
          </h3>
        </div>
        <div class="col-auto d-flex align-items-center">
          <label class="mb-0 mr-2 small" for="filter_enabled_only">Enable only</label>
          <base-switch id="filter_enabled_only" v-model="enabledOnly"></base-switch>
        </div>
      </div>

      <base-alert type="success" class="mt-3" v-if="successMessage">
        The changes have been successfully saved.
      </base-alert>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="items"
      >
        <template v-slot:columns>
          <th style="cursor: pointer;" @click="sortBy('lastName')" :class="{ 'text-dark font-weight-bold' : filters['order[lastName]']}">
            Last Name
            <i v-if="filters['order[lastName]'] === 'asc'" class="fa fa-arrow-up"></i>
            <i v-if="filters['order[lastName]'] === 'desc'" class="fa fa-arrow-down"></i>
          </th>
          <th style="cursor: pointer;" @click="sortBy('firstName')" :class="{ 'text-dark font-weight-bold' : filters['order[firstName]']}">
            First Name
            <i v-if="filters['order[firstName]'] === 'asc'" class="fa fa-arrow-up"></i>
            <i v-if="filters['order[firstName]'] === 'desc'" class="fa fa-arrow-down"></i>
          </th>
          <th style="cursor: pointer;" @click="sortBy('email')" :class="{ 'text-dark font-weight-bold' : filters['order[email]']}">
            Email
            <i v-if="filters['order[email]'] === 'asc'" class="fa fa-arrow-up"></i>
            <i v-if="filters['order[email]'] === 'desc'" class="fa fa-arrow-down"></i>
          </th>
          <th>Status</th>
          <th style="cursor: pointer;" @click="sortBy('group.name')" :class="{ 'text-dark font-weight-bold' : filters['order[group.name]']}">
            Group
            <i v-if="filters['order[group.name]'] === 'asc'" class="fa fa-arrow-up"></i>
            <i v-if="filters['order[group.name]'] === 'desc'" class="fa fa-arrow-down"></i>
          </th>
          <th class="text-center">Admin</th>
          <th class="text-center">Super Admin</th>
          <th></th>
        </template>

        <template v-slot:default="row">
          <th scope="row">
            <span class="name mb-0 text-sm">{{row.item.lastName}}</span>
          </th>
          <td>
            {{ row.item.firstName }}
          </td>
          <td>
            {{ row.item.email }}
          </td>
          <td>
            <badge class="mr-4" :type="itemType(row.item)">
              <span class="status">{{ itemTypeStr(row.item) }}</span>
            </badge>
          </td>
          <td>
            {{row.item.group.name}}
          </td>
          <td class="text-center">
            <i class="fa fa-check text-success" v-if="row.item.isAdmin"></i> 
          </td>
          <td class="text-center">
            <i class="fa fa-check text-success" v-if="row.item.superAdmin"></i> 
          </td>

          <td class="text-right">
            <button v-if="row.item.enabled" class="btn btn-danger btn-sm"  @click="disabledItem(row.item)">Disable</button>
            <button v-if="!row.item.enabled" class="btn btn-success btn-sm" @click="enabledItem(row.item)">Enable</button>
            <button class="btn btn-icon btn-primary btn-sm" @click="showEditModal(row.item)">
              <span class="btn-inner--icon"><i class="fa fa-edit"></i></span>
              <span class="btn-inner--text">Edit</span>
            </button>
          </td>
        </template>
      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end">
      <base-pagination :total="totalItems" perPage=20 v-model="currentPage"></base-pagination>
    </div>

     <modal v-model:show="showModal">
      <template v-slot:header>
          <h5 class="modal-title" v-if="item.id">Edit {{item.email}} account</h5>
      </template>
      <form id=item-form role="form" @submit.prevent="handleForm(!v$.$invalid)" novalidate>
        <div class="form-group">
          <label for="item_group">Group</label>
          <select id="item_group" class="form-control" v-model="v$.item.group.$model">
            <option v-for="group in groups" :key="group.id" v-bind:value="group['@id']">{{group.name}}</option> 
          </select>
        </div>
        <div class="mt-3">
          <label for="item_message" class="form-label">Status</label>
          <div>
            <base-switch v-model="v$.item.enabled.$model"></base-switch>
          </div>
        </div>
        <div class="mt-3">
          <label class="form-label">Admin</label>
          <div>
            <base-switch v-model="v$.item.isAdmin.$model"></base-switch>
          </div>
        </div>
        <div class="mt-3">
          <label class="form-label">Super Admin</label>
          <div>
            <base-switch v-model="v$.item.superAdmin.$model"></base-switch>
          </div>
        </div>
      </form>
      <template v-slot:footer>
          <base-button type="secondary" @click="showModal = false">Cancel</base-button>
          <base-button nativeType="submit" type="primary" form="item-form">Save</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import moment from 'moment';
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: "users-table",
  setup: () => ({ v$: useVuelidate() }),
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  created() {
		this.reloadData();
    this.$resources.groups.list().then(response => (this.groups = response.data));
	},
  data() {
    return {
      items: [],
      totalItems: 0,
      groups: [],
      showModal: false,
      item: {},
      isSubmitted: false,
      successMessage: false,
      currentPage: 1,
      enabledOnly: false,
      filters: {
        'order[lastName]': 'asc'
      }
    };
  },
  validations() {
    return {
        item: {
            group: {required}, 
            enabled: {},
            superAdmin: {},
            isAdmin: {} 
        } 
    } 
  },
  watch: {
    currentPage() {
      this.reloadData();
    },
    enabledOnly() {
      this.currentPage = 1;
      this.reloadData();
    }
  },
  methods:{
    reloadData() {
      const filters = { ...this.filters };
      if (this.enabledOnly) {
        filters.enabledOnly = true;
      }
      this.$resources.users
        .list(this.currentPage, filters)
        .then(response => {
          this.items = response.data;
          this.totalItems = response.totalItems;
        });
    },
    sortBy(field) {
      const orderKey = `order[${field}]`;
      const currentOrder = this.filters[orderKey];
      const orderKeys = ['order[lastName]', 'order[firstName]', 'order[email]', 'order[group.name]'];
      orderKeys.forEach(key => {
        if (key !== orderKey) delete this.filters[key];
      });
      this.filters[orderKey] = currentOrder === 'asc' ? 'desc' : 'asc';
      this.currentPage = 1;
      this.reloadData();
    },
    itemType(item) { 
      return item.enabled ? 'success' : 'danger';
    } ,
    itemTypeStr(item) {
      return item.enabled ? 'On' : 'Off';
    },
    dateFormat(date) {
      return moment(String(date)).format('L LTS');
    },
    showEditModal(item) {
      this.isSubmitted = false;
      this.showModal = true;
      this.item = {...item};
      this.item.group = this.item.group['@id']; 
    },
    showCreateModal() {
      this.isSubmitted = false;
      this.showModal = true;
      this.item = {
        enabled: false
      };
    },
    isValid(item){
        if (!this.isSubmitted){
          return null;
        } 

        return !item.$invalid;
    },
    handleForm(isValid) {
      this.isSubmitted = true;

      if (!isValid) return;

      this.saveItem(this.item, true);
    },
    saveItem(item, showAlert){
      if (item.superAdmin && !item.roles.includes('ROLE_ADMIN')) {
        item.isAdmin = true;
      } 

      if (item.isAdmin) {
        item.roles = ['ROLE_USER', 'ROLE_ADMIN'];
      } else {
        item.roles = ['ROLE_USER'];
        item.superAdmin = false;
      }  



        this.$resources.users.update(item.id, item).then( (data) => {
            this.reloadData();
            
            showAlert && (this.successMessage = true);
            this.items[this.findIndexById(item.id)] = data;

            this.showModal = false; 
            this.item = {};

        });
    },
    enabledItem(item) {
        let upItem = {...item};
        upItem.group = item.group['@id'];
        upItem.enabled = true;
        this.saveItem(upItem, false);
    },
    disabledItem(item) {
        let upItem = {...item};
        upItem.group = item.group['@id'];
        upItem.enabled = false;
        this.saveItem(upItem, false);
    }, 
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === id) {
              index = i;
              break;
          }
      }
      return index;
    } 
  }
};
</script>
<style></style>
